<template>
  <div class="address-book">
		<div style="display: flex; justify-content: space-between">
			<button v-if="userRole == 'admin'" class="add" @click="add">添加</button>
		</div>
		<div style="height: 20px"></div>
		<el-table :data="tableData" border :cell-style="{height: '60px',boxSizing: 'border-box',borderColor: '#f5f5f5'}" header-cell-class-name="table-header-cell">
			<el-table-column type="index" label="序号" width="50" align="center" :resizable="false"></el-table-column>
			<el-table-column prop="avatar" label="头像" width="70" v-slot="{ row }" align="center" :resizable="false">
				<img class="table-avatar" :src="row.avatar" alt="" />
			</el-table-column>
			<el-table-column prop="name" label="姓名" width="100" align="center" :resizable="false"></el-table-column>
			<el-table-column prop="mobile" label="手机" align="center" :resizable="false"></el-table-column>
			<el-table-column prop="tel" label="座机" align="center" :resizable="false"></el-table-column>
			<el-table-column prop="department" label="部门" align="center" :resizable="false"></el-table-column>
			<el-table-column prop="position" label="职位" align="center" :resizable="false"></el-table-column>
			<!-- <el-table-column prop="username" label="邮箱" align="center" :resizable="false"></el-table-column> -->
			<el-table-column label="操作" align="center" :resizable="false" v-slot="{row}" v-if="userRole == 'admin'">
				<div style="color: #4a73ff; font-size: 14px; cursor: pointer" v-if="userRole == 'admin' && uid !== row.uid">
					<span @click="turnOver(row.uid)">移交</span>
					<span style="margin-left: 7px; margin-right: 7px">|</span>
					<span @click="handleDelete(row.uid)">删除</span>
				</div>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {Api} from "../../utils/axios.js"
export default {
  data: () => ({
    tableData: [],
    copyData: [],
	userRole:'',
	uid:sessionStorage.getItem('uid')
  }),
  created() {
	var user = JSON.parse(sessionStorage.getItem('USERINFO'))
	this.userRole  = user.company.power
	this.loadData()
  },
  methods: {
    loadData() {
      Api('user/getPartner',{}).then((res) => {
      	if(res.code==200){
      		 this.copyData = this.tableData = res.result
      	}else{
      		this.$message.error(res.msg);
      	}
      })
    },
    async turnOver(uid) {
      this.$confirm('确认移交吗？')
        .then(async () => {
			Api('user/changeAdmin',{id:uid,company_id:sessionStorage.getItem('company')}).then((res) => {
				if(res.code==200){
					Api('user',{}).then((res) => {
						if(res.code==200){
							this.userRole = res.result.company.power
							sessionStorage.setItem('COMPANY',res.result.company[0].id)
							sessionStorage.setItem('USERINFO',JSON.stringify(res.result))
							location.reload()
						}else{
							this.$message.error(res.msg);
						}
					})
				}else{
					this.$message.error(res.msg);
				}
			})
        })
        .catch(() => {})
    },
    async handleDelete(uid) {
      this.$confirm('确认删除吗？')
        .then(async () => {
          Api('user/removeUser',{id:uid,company_id:sessionStorage.getItem('company')}).then((res) => {
          	if(res.code==200){
          		Api('user',{}).then((res) => {
          			if(res.code==200){
          				location.reload()
          			}else{
          				this.$message.error(res.msg);
          			}
          		})
          	}else{
          		this.$message.error(res.msg);
          	}
          })
        })
        .catch(() => {})

      // console.log(res)
      // this.copyData = this.tableData = res.result
    },
    add() {
		this.$router.push('manageSave')
    },
    handleSearch(keywords) {
		this.tableData = this.copyData.filter(v => v.name.includes(keywords))
    }
  }
}
</script>

<style scoped>
.address-book {
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
}
.table-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.add {
  width: 120px;
  height: 40px;
  background: #4a73ff;
  border-radius: 6px;
  border: none;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  float: right;
}
</style>
